import { render } from "./Header.vue?vue&type=template&id=130c831f&scoped=true&bindings={\"toggleMenu\":\"setup\",\"logOut\":\"setup\",\"navigate\":\"setup\",\"isActiveBtn\":\"setup\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=130c831f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-130c831f"

export default script